import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import '../Common/styles/Charts.css';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { menus } from './Common/Consts/sidebar';
import { HomeNav } from '../Common/Home/HomeNav';
import SecurityFiltersProvider from './Common/Filters/contexts/SecurityFiltersContext';
import CriminalData from './CriminalData/CriminalData';
import Vehicles from './Vehicles/Vehicles';
import Phones from './Phones/Phones';
import Objects from './Objects/Objects';
import PoliceInterventionDeaths from './PoliceInterventionDeaths/PoliceInterventionDeaths';
import IML from './IML/IML';

function DashBoardSecurity() {
    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <SecurityFiltersProvider>
                <ReactQueryDevtools initialIsOpen={false} />
                <div className="dashboards-page">
                    <HomeNav menus={menus} />
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate to="criminal-data" replace />}
                        />
                        <Route
                            path="/criminal-data/*"
                            element={
                                <CriminalData
                                    dashboardPath={'dashboardsecurity'}
                                    menuPath={'criminal-data'}
                                />
                            }
                        />
                        <Route
                            path="/vehicles/*"
                            element={
                                <Vehicles
                                    dashboardPath={'dashboardsecurity'}
                                    menuPath={'vehicles'}
                                />
                            }
                        />
                        <Route
                            path="/phones/*"
                            element={
                                <Phones
                                    dashboardPath={'dashboardsecurity'}
                                    menuPath={'phones'}
                                />
                            }
                        />
                        <Route
                            path="/objects/*"
                            element={
                                <Objects
                                    dashboardPath={'dashboardsecurity'}
                                    menuPath={'objects'}
                                />
                            }
                        />
                        <Route
                            path="/deathsByPoliceIntervention/*"
                            element={
                                <PoliceInterventionDeaths
                                    dashboardPath={'dashboardsecurity'}
                                    menuPath={'deathsByPoliceIntervention'}
                                />
                            }
                        />
                        <Route
                            path="/iml/*"
                            element={
                                <IML
                                    dashboardPath={'dashboardsecurity'}
                                    menuPath={'iml'}
                                />
                            }
                        />
                    </Routes>
                </div>
            </SecurityFiltersProvider>
        </QueryClientProvider>
    );
}

export default DashBoardSecurity;
